"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEndpointMappings = validateEndpointMappings;
/**
 * Validates that the authorization model is consistent:
 * - All endpoints in projectRoleEndpointMap exist in serverUserEndpointsConst
 * - All endpoints in serverUserEndpointsConst are assigned to at least one role
 *
 * Called at server startup. Throws if invalid.
 */
const dbschema_1 = require("@karya/dbschema");
const Index_1 = require("../apis/server-user-apis/Index");
function validateEndpointMappings() {
    const validEndpointsSet = new Set(Index_1.serverUserEndpointsConst);
    const errors = [];
    for (const role of dbschema_1.projectRoles) {
        const endpoints = Index_1.projectRoleEndpointMap[role];
        for (const endpoint of endpoints) {
            if (!validEndpointsSet.has(endpoint)) {
                errors.push(`Endpoint "${endpoint}" in ${role} is not in serverUserEndpointsConst`);
            }
        }
    }
    const assignedEndpoints = new Set();
    for (const role of dbschema_1.projectRoles) {
        for (const endpoint of Index_1.projectRoleEndpointMap[role]) {
            assignedEndpoints.add(endpoint);
        }
    }
    for (const endpoint of Index_1.serverUserEndpointsConst) {
        if (!assignedEndpoints.has(endpoint)) {
            errors.push(`Endpoint "${endpoint}" is in serverUserEndpointsConst but not assigned to any role in projectRoleEndpointMap`);
        }
    }
    if (errors.length > 0) {
        throw new Error(`Endpoint mapping validation failed:\n${errors.map((e) => `  - ${e}`).join('\n')}`);
    }
}
//# sourceMappingURL=validateEndpointMappings.js.map